import React, { useState } from "react";
import { useSwipeable } from "react-swipeable";

const testimonials = [
  {
    text: "Rashid was the most knowledgeable and warmest guide we have ever had. He took beautiful photos, explained the history of the dunes and made sure everyone in our group felt safe and having fun. The evening safari was the highlight of our entire Dubai trip — we still talk about it.",
    customer: "Agnetha L., New York",
    image: "/images/home/dummy.jpg",
    rating: "⭐⭐⭐⭐⭐",
  },
  {
    text: "We did the morning safari with quad biking and it was absolutely brilliant. Taj was incredible — funny, professional, and an expert driver on those dunes. The sunset photos he took of us were professional quality. We would book with Bonvoy Tourism again in a heartbeat.",
    source: "Review of: Dubai City Tour Full Day with Burj Khalifa Ticket At the Top",
    customer: "Crawleyite, Winchester, UK",
    image: "/images/home/dummy.jpg",
    rating: "⭐⭐⭐⭐⭐",
  },
  {
    text: "Amazing Dubai and Abu Dhabi city tour with Mr. Rashid. He provided fascinating historical facts about every landmark, took stunning photos, and made the whole day so smooth. Highly recommended to anyone visiting Dubai for the first time!",
    source: "Review of: Dubai City Tour Full Day with Burj Khalifa Ticket At the Top",
    customer: "Nur Zihan, Malaysia",
    image: "/images/home/dummy.jpg",
    rating: "⭐⭐⭐⭐⭐",
  },
];

export default function ReviewCTR() {
  const [current, setCurrent] = useState(0);

  const handlers = useSwipeable({
    onSwipedLeft: () =>
      setCurrent((prev) => (prev + 1) % testimonials.length),
    onSwipedRight: () =>
      setCurrent((prev) => (prev - 1 + testimonials.length) % testimonials.length),
    trackMouse: true,
  });

  return (
    <div className="mt-12 md:mt-22">
      <h3 className="text-[20px] md:text-[24px] lg:text-[30px] text-[#666] font-semibold mb-4">
        What Our Guests Say — 5.0 ★ on TripAdvisor
      </h3>
      <div className="relative grid grid-cols-1 lg:grid-cols-2 items-stretch overflow-hidden">
        <div
          {...handlers}
          className="order-2 lg:order-1 flex flex-col justify-center p-[20px] lg:p-[90px] bg-[#f9f9f9] relative"
        >
          <div className="italic border border-[#fc9f1c] p-[20px] lg:p-[40px] mb-[25px]">
            <p className="text-[13px] text-[#606060] leading-[25px] lg:leading-[40px] mb-[10px]">
              {testimonials[current].text}
            </p>
            <p className="text-[13px] text-[#606060]">
            </p>
          </div>

          <div className="flex items-center gap-4 lg:gap-8">
            <img
              src={testimonials[current].image}
              alt="customer"
              className="w-[93px] h-[97px] rounded-full object-cover"
            />
            <div className="flex flex-col">
              <h3 className="text-[14px] font-semibold text-[#606060]">
                {testimonials[current].customer}
              </h3>
              <h3 className="text-[14px] font-semibold text-[#606060]">
                {testimonials[current].rating}
              </h3>
            </div>
          </div>

          {/* DOTS */}
          <div className="absolute bottom-4 right-4 flex gap-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrent(index)}
                className={`w-2 h-2 lg:w-3 lg:h-3 rounded-full transition-colors duration-300 ${current === index ? "bg-[#fc9f1c]" : "bg-gray-400"
                  }`}
              />
            ))}
          </div>
        </div>

        {/* RIGHT IMAGE */}
        <div className="order-1 lg:order-2 w-full h-full">
          <img
            src="/images/home/reviewhome.jpg"
            alt="review"
            className="w-full h-full object-cover"
          />
        </div>
      </div>
    </div>
  );
}
